import ResponseBodyDownload_vue_vue_type_script_setup_true_lang_default from "./ResponseBodyDownload.vue.script.js";
//#region src/v2/blocks/response-block/components/ResponseBodyDownload.vue
var ResponseBodyDownload_default = ResponseBodyDownload_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ResponseBodyDownload_default as default };

//# sourceMappingURL=ResponseBodyDownload.vue.js.map